import React from "react";
import { Link } from "react-router-dom";
import "./SideNavBar.css";
import { MdAirplaneTicket } from "react-icons/md";
import { MdGroupWork } from "react-icons/md";
import { RiSecurePaymentFill } from "react-icons/ri";
import { FaListAlt } from "react-icons/fa";
import { showHideController } from "../../../common/normal";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { FaRegClone } from "react-icons/fa";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import DirectTopUpForMobile from "../DirectTopUp/DirectTopUpForMobile";

const SideNavBar = () => {
  let isAgent = JSON.parse(sessionStorage.getItem("isAgent"));

  let permissionDepositeSharePnr = JSON.parse(
    sessionStorage.getItem("permissionDepositeSharePnr")
  );
  const handelLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
    sessionStorage.setItem("popup", JSON.stringify(false));
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <aside
      className="main-sidebar sidebar-dark-primary elevation-4 button-color"
      style={{ position: "fixed", height: "100%" }}
    >
      <div className="sidebar" style={{ overflow: "hidden" }}>
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li className="nav-item">
              <Link to="/dashboard" className="nav-link">
                <i className="nav-icon fa fa-desktop text-white"></i>
                <p className="text-white">Dashboard</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/search" className="nav-link">
                <i className="nav-icon fas fa-search text-white"></i>
                <p className="text-white">Search</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/my-bookings" className="nav-link">
                <FaListAlt
                  className="nav-icon fa fa-list text-white"
                  style={{ fontSize: "20px" }}
                />
                <p className="text-white">My Booking</p>
              </Link>
            </li>
            {permissionDepositeSharePnr?.sharePnr && (
              <li className="nav-item">
                <Link to="/share-pnr" className="nav-link">
                  <i className="nav-icon fas fa-file-import text-white"></i>
                  <p className="text-white">Share PNR</p>
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link to="/soto-ticket" className="nav-link">
                <MdAirplaneTicket
                  className="nav-icon fa fa-list text-white"
                  style={{ fontSize: "23px" }}
                />
                <p className="text-white">Ticket Alert</p>
              </Link>
            </li>
            {isAgent && (
              <li className="nav-item">
                <Link to="/hold-balance" className="nav-link">
                  <MdOutlineAccountBalanceWallet
                    className="nav-icon fas fa-user text-white"
                    style={{ fontSize: "23px" }}
                  />
                  <p className="text-white">Hold Balance</p>
                </Link>
              </li>
            )}

            {isAgent && (
              <li className="nav-item">
                <Link to="/fare-change-quotation" className="nav-link">
                  <FaRegClone
                    className="nav-icon fas fa-user text-white"
                    style={{ fontSize: "23px" }}
                  />
                  <p className="text-white">Fare Change Quotation</p>
                </Link>
              </li>
            )}

            {showHideController?.groupFare && (
              <li className="nav-item">
                <Link to="/fare-list" className="nav-link">
                  <MdGroupWork
                    className="nav-icon fa fa-list text-white"
                    style={{ fontSize: "23px" }}
                  />
                  <p className="text-white">Group Fare</p>
                </Link>
              </li>
            )}

            {isAgent && (
              <li className="nav-item">
                <Link to="/partial-payment" className="nav-link">
                  <RiSecurePaymentFill
                    className="nav-icon fa fa-list text-white"
                    style={{ fontSize: "23px" }}
                  />
                  <p className="text-white">Scheduled Payment</p>
                </Link>
              </li>
            )}

            {isAgent && (
              <li className="nav-item">
                <Link to="/balance" className="nav-link">
                  <i className="nav-icon fas fa-comment-dollar text-white"></i>
                  <p className="text-white">Payment Request</p>
                </Link>
              </li>
            )}

            {isAgent && permissionDepositeSharePnr?.onlineDeposit && (
              <li className="nav-item d-block d-md-none" onClick={() => onOpen()}>
                <div className="nav-link" style={{ cursor: "pointer" }}>
                  <i className="nav-icon fas fa-comment-dollar text-white"></i>
                  <p className="text-white">Direct Payment</p>
                </div>
              </li>
            )}
            <li className="nav-item">
              <Link to="/support" className="nav-link">
                <i className="nav-icon fas fa-headset text-white"></i>
                <p className="text-white">Support</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/all-Report" className="nav-link">
                <i
                  className="nav-icon  fa fa-file text-white"
                  aria-hidden="true"
                ></i>
                <p className="text-white">Reports</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/quickpassenger" className="nav-link">
                <i className="nav-icon fas fa-users text-white"></i>
                <p className="text-white">Add Passenger</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/setting" className="nav-link">
                <i
                  className="nav-icon fa fa-cog text-white"
                  aria-hidden="true"
                ></i>
                <p className="text-white">Settings</p>
              </Link>
            </li>

            {isAgent && (
              <li className="nav-item">
                <Link to="/staff" className="nav-link">
                  <i className="nav-icon fas fa-user text-white"></i>
                  <p className="text-white">My Users</p>
                </Link>
              </li>
            )}

            {isAgent && (
              <li className="nav-item">
                <Link to="/adm-defender" className="nav-link">
                  <i className="nav-icon fas fa-calendar text-white"></i>
                  <p className="text-white">ADM Defender</p>
                </Link>
              </li>
            )}

            <li className="nav-item">
              <div
                className="nav-link"
                onClick={handelLogout}
                style={{ cursor: "pointer" }}
              >
                <i className="nav-icon fas fa-sign-out-alt text-white"></i>
                <p className="text-white">Logout</p>
              </div>
            </li>
          </ul>
        </nav>
      </div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <DirectTopUpForMobile onClick={onClose}/>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </aside>
  );
};

export default SideNavBar;
